import { render, staticRenderFns } from "./InterventionEditorDetails.vue?vue&type=template&id=495220ba&scoped=true"
import script from "./InterventionEditorDetails.vue?vue&type=script&lang=js"
export * from "./InterventionEditorDetails.vue?vue&type=script&lang=js"
import style0 from "./InterventionEditorDetails.vue?vue&type=style&index=0&id=495220ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495220ba",
  null
  
)

export default component.exports